import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TenantForwardGuard  {
  constructor(private authenticationService: AuthenticationService,
              private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const result = new Subject<boolean>();
    this.authenticationService.isAuthenticated().subscribe(
      res => {
        if (res) {
          this.router.navigateByUrl('/home');
          result.next(false);
          result.complete();
        } else {
          result.next(true);
          result.complete();
        }
      }, error => {
        result.next(true);
        result.complete();
      }
    );
    return result.asObservable();
  }

}
